import axios from "axios";
import { z } from "zod";

const ClubProfileZ = z.object({
	Name: z.string(),
	LogoURL: z.string(),
	WebsiteURL: z.string()
});

export type ClubProfile = z.infer<typeof ClubProfileZ>;

export const getClubProfile = async (clubId: string) => {
	const profileUrl = `/orgsproducts/organisation/${clubId}`;

	const response = await axios.get(profileUrl);
	const clubProfile = ClubProfileZ.parse(response.data);
	return clubProfile;
};
